import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import Heading from './Heading';
import Text from './Text';
import { StyledWrapper, StyledImg, StyledImgText, StyledImgWrapper } from './Nameplate.styled';
var Nameplate = function Nameplate(_ref) {
  var heading = _ref.heading,
    logo = _ref.logo,
    skeleton = _ref.skeleton,
    subHeading = _ref.subHeading,
    title = _ref.title;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      alignItems: 'center',
      px: isMobile ? 2 : 0,
      py: 4
    }
  }, skeleton ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: isMobile ? '80%' : '40%',
    height: isMobile ? 22 : 30
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: isMobile ? '60%' : '30%',
    height: isMobile ? 22 : 30
  })), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rect",
    height: 100,
    width: 100
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    variant: "body1",
    weight: "600"
  }, isMobile && /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("small", null, title)), !isMobile && title), /*#__PURE__*/React.createElement(Heading, {
    as: isMobile ? 'h5' : 'h3',
    weight: "400",
    color: "textPrimary",
    gutterBottom: false
  }, heading, subHeading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), " ", subHeading))), /*#__PURE__*/React.createElement(StyledImgWrapper, null, logo && /*#__PURE__*/React.createElement(StyledImg, {
    src: logo,
    alt: heading
  }), !logo && heading && /*#__PURE__*/React.createElement(StyledImgText, null, heading[0].toUpperCase()))))));
};
Nameplate.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Heading
   */
  heading: PropTypes.string,
  /**
   * Sub Heading
   */
  subHeading: PropTypes.string,
  /**
   * Show skeleton layout
   */
  skeleton: PropTypes.bool,
  /**
   * URL for the property manager logo
   */
  logo: PropTypes.string,
  /**
   * Text displayed before heading
   */
  title: PropTypes.string
} : {};
Nameplate.defaultProps = {
  heading: '',
  subHeading: '',
  skeleton: false,
  logo: '',
  title: ''
};
export default Nameplate;